
import { defineComponent, PropType } from 'vue'

import RepoSearchQuery from '~/apollo/queries/repository/searchList.gql'

import { getAgentKindIcon, getAgentKindName } from '~/utils/agents'

import type { ApolloQueryResult } from 'apollo-client'
import type { SearchRepoT } from '~/components/Repository/RepoSearch.vue'
import { AgentKind, RepositoryKindChoices, RepositorySearchListQuery } from '~/types/types'

export interface AddMemoryPayload {
  repositoryId?: string | null
  agentKind?: AgentKind | null
  content: string
}

export default defineComponent({
  name: 'AddMemoryModal',
  data() {
    return {
      selectedKind: null as AgentKind | null,
      memoryContent: '' as string,
      repoSearchString: '' as string,
      selectedRepoId: null as string | null,
      repoList: [] as SearchRepoT[]
    }
  },
  props: {
    contextKind: {
      type: String as PropType<AgentKind> | null,
      default: null
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    AgentKind() {
      return AgentKind
    },
    isValid() {
      return this.memoryContent.trim() !== ''
    }
  },
  mounted() {
    if (this.contextKind) {
      this.selectedKind = this.contextKind
    }
  },
  methods: {
    getAgentKindIcon,
    getAgentKindName,
    async handleRepoSearch(searchString: string) {
      this.repoSearchString = searchString
      try {
        const { owner: login, provider } = this.$route.params

        if (!login || !provider) {
          throw new Error('Missing required parameters')
        }

        const response: ApolloQueryResult<RepositorySearchListQuery> = await this.$fetchGraphqlData(
          RepoSearchQuery,
          {
            login,
            provider: this.$providerMetaMap[provider].value,
            query: searchString,
            kindIn: [RepositoryKindChoices.Repo, RepositoryKindChoices.Subrepo],
            limit: 10
          }
        )

        if (response.data) {
          this.repoList =
            response.data.owner?.repositories?.edges?.map((repoEdge) => ({
              id: repoEdge?.node?.id ?? '',
              name: repoEdge?.node?.displayName ?? '',
              owner: repoEdge?.node?.ownerLogin ?? ''
            })) || []
        }
      } catch (error) {
        this.$logErrorAndToast(error as Error, 'Failed to fetch list of repositories.')
      }
    },
    handleRepoSubmit(repo: SearchRepoT) {
      this.selectedRepoId = repo.id
      this.repoSearchString = repo.name
    },
    handleAddMemory() {
      const payload: AddMemoryPayload = {
        repositoryId: this.selectedRepoId,
        content: this.memoryContent,
        agentKind: this.contextKind ? this.contextKind : this.selectedKind
      }
      this.$emit('add-memory', payload)
    }
  },
  async fetch() {
    await this.handleRepoSearch(this.repoSearchString)
  }
})
